var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlinePlayCircleFilledWhiteCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0V0C31.0457 0 40 8.9543 40 20V20C40 31.0457 31.0457 40 20 40V40C8.9543 40 0 31.0457 0 20V20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C14.48 10 10 14.48 10 20C10 25.52 14.48 30 20 30C25.52 30 30 25.52 30 20C30 14.48 25.52 10 20 10ZM20 28C15.59 28 12 24.41 12 20C12 15.59 15.59 12 20 12C24.41 12 28 15.59 28 20C28 24.41 24.41 28 20 28ZM18 24.5L24 20L18 15.5V24.5Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlinePlayCircleFilledWhiteCircle40Px);
export default __webpack_public_path__ + "static/media/ic_outline-play_circle_filled_white_circle-40px.fa96b664c2caabbb7a585d4a58cf3d99.svg";
export { ForwardRef as ReactComponent };